var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrmApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.7 2.8)",
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.128 2.1a2 2 0 011.997 1.897l.366 7.09a2 2 0 01-1.894 2.101l-.051.002h-8.44a2 2 0 01-2-2l.003-.102.366-7.091A2 2 0 012.472 2.1h7.656zm0 1H2.472a1 1 0 00-.986.836l-.013.112-.367 7.143a1 1 0 00.883.993l.117.007 8.44-.001a1 1 0 00.946-.934v-.117l-.365-7.09a1 1 0 00-.887-.943l-.112-.006z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3-.5a3.5 3.5 0 013.495 3.308L9.8 3h-1a2.5 2.5 0 00-4.995-.164L3.8 3h-1A3.5 3.5 0 016.3-.5zM6.3 9.6a3.5 3.5 0 003.5-3.5.5.5 0 00-1 0 2.5 2.5 0 01-5 0 .5.5 0 00-1 0 3.5 3.5 0 003.5 3.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.3,
    cy: 5.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.3,
    cy: 5.1,
    r: 1
  }))));
}

export default SvgCrmApps;